import { observer } from "mobx-react-lite";
import { useRootStore } from "../../stores/hooks";
import { t } from "i18next";
import { InfoIconButton } from "../../elements/InfoIconButton/InfoIconButton";
import { WelcomeAutomationsContent } from "./WelcomeAutomationsContent";
import { AutomationListContent } from "./AutomationListContent";
import { EmptyBodyStyle } from "./style";
import {
  INPUT_APPLICATION_ID,
  Integrations,
  isSmartSuiteIntegration,
} from "../../utils/constants";
import { intercomOpenAutomationsArticle } from "../../services/intercom.service";
import { findInputAndPick, pickValueConfigString } from "../../utils/inputs";
import PreloaderAutomations from "../../../generated/images/PreloaderAutomations";
import { ConnectionLost } from "../../components/ConnectionLost";
import { Modal, ModalHeader } from "@smartsuite/react-ui/lib";

export const AutomationList = observer<{
  onClose?: () => void;
  isLoading: boolean;
  loadingErr?: string;
}>(({ isLoading, onClose, loadingErr }) => {
  const store = useRootStore();
  const { automations, applications } = store;

  const automationsWithValidTriggerAndApplication = automations.list.filter(
    (item) => {
      const integrationId = String(
        item.trigger?.triggerReference?.integrationId,
      );
      if (
        isSmartSuiteIntegration(integrationId) &&
        integrationId !== Integrations.webhooks
      ) {
        if (item.trigger?.inputs && item.trigger?.inputs.length > 0) {
          const applicationId = findInputAndPick(
            item.trigger.inputs,
            INPUT_APPLICATION_ID,
            pickValueConfigString,
          );
          return applications.list.some((app) => app.id === applicationId);
        }
        return false;
      }
      return true;
    },
  );

  const isNoTriggers = automationsWithValidTriggerAndApplication.length === 0;

  return (
    <Modal
      size="XL"
      styles={{
        minWidth: "980px",
        maxWidth: "1380px",
        height: !isNoTriggers ? "calc(100vh - 60px)" : "",
        display: "flex",
      }}
      bodyStyles={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
      header={
        <ModalHeader
          title={t("automation-list.modal-header-title")}
          subtitle={t("automation-list.modal-header-subtitle")}
          iconSize="XL"
          iconName={"automations"}
          actions={
            <InfoIconButton
              iconName="question-circle"
              onClick={intercomOpenAutomationsArticle}
            />
          }
        />
      }
      onClose={() => onClose?.()}
    >
      {loadingErr ? (
        <ConnectionLost msg={loadingErr} />
      ) : (
        <>
          {isLoading && (
            <EmptyBodyStyle>
              <PreloaderAutomations />
            </EmptyBodyStyle>
          )}
          {!isLoading &&
            (isNoTriggers ? (
              <WelcomeAutomationsContent />
            ) : (
              <AutomationListContent onClose={onClose} />
            ))}
        </>
      )}
    </Modal>
  );
});
AutomationList.displayName = "AutomationList";
